function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".step_2_svg__a{fill:#614cb4}.step_2_svg__b{fill:#eae9ef}.step_2_svg__c{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(23.269 13.831)"
}, /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__a",
  d: "M23.654.001H3.114A3.113 3.113 0 000 3.115v13.978a3.113 3.113 0 003.114 3.114h20.54a3.114 3.114 0 003.114-3.114V3.115A3.114 3.114 0 0023.655.001zM38.143 3.114v13.982a3.114 3.114 0 003.114 3.114h20.54a3.114 3.114 0 003.113-3.114V3.116A3.114 3.114 0 0061.796.002h-20.54a3.114 3.114 0 00-3.113 3.112z"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__b",
  d: "M76.285 3.114v13.982a3.114 3.114 0 003.114 3.114h20.54a3.114 3.114 0 003.113-3.114V3.116A3.114 3.114 0 0099.938.002h-20.54a3.114 3.114 0 00-3.113 3.112zM.001 34.056v13.982a3.114 3.114 0 003.114 3.114h20.54a3.114 3.114 0 003.113-3.114v-13.98a3.114 3.114 0 00-3.114-3.114H3.114a3.114 3.114 0 00-3.113 3.112zM38.143 34.056v13.982a3.114 3.114 0 003.114 3.114h20.54a3.114 3.114 0 003.113-3.114v-13.98a3.114 3.114 0 00-3.114-3.114h-20.54a3.114 3.114 0 00-3.113 3.112z"
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__a",
  d: "M76.285 34.056v13.982a3.114 3.114 0 003.114 3.114h20.54a3.114 3.114 0 003.113-3.114v-13.98a3.114 3.114 0 00-3.114-3.114h-20.54a3.114 3.114 0 00-3.113 3.112z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "step_2_svg__c",
  cx: 4.281,
  cy: 4.281,
  transform: "translate(9.102 5.823)",
  r: 4.281
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__c",
  d: "M19.926 20.595H6.841a6.492 6.492 0 011.169-1.6 6.4 6.4 0 014.54-1.88h1.666a6.42 6.42 0 015.71 3.48z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "step_2_svg__c",
  cx: 4.281,
  cy: 4.281,
  transform: "translate(47.245 5.823)",
  r: 4.281
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__c",
  d: "M58.068 20.595H44.983a6.492 6.492 0 011.17-1.6 6.4 6.4 0 014.54-1.88h1.666a6.42 6.42 0 015.71 3.479z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "step_2_svg__c",
  cx: 4.281,
  cy: 4.281,
  transform: "translate(85.387 5.823)",
  r: 4.281
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__c",
  d: "M96.21 20.595H83.125a6.492 6.492 0 011.169-1.6 6.4 6.4 0 014.54-1.88H90.5a6.42 6.42 0 015.71 3.48z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "step_2_svg__c",
  cx: 4.281,
  cy: 4.281,
  transform: "translate(9.102 36.764)",
  r: 4.281
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__c",
  d: "M19.926 51.538H6.841a6.494 6.494 0 011.169-1.6 6.4 6.4 0 014.54-1.88h1.666a6.42 6.42 0 015.71 3.48z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "step_2_svg__c",
  cx: 4.281,
  cy: 4.281,
  transform: "translate(47.245 36.764)",
  r: 4.281
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__c",
  d: "M58.068 51.538H44.983a6.494 6.494 0 011.17-1.6 6.4 6.4 0 014.54-1.88h1.666a6.419 6.419 0 015.71 3.48z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "step_2_svg__c",
  cx: 4.281,
  cy: 4.281,
  transform: "translate(85.387 36.764)",
  r: 4.281
}), /*#__PURE__*/React.createElement("path", {
  className: "step_2_svg__c",
  d: "M96.21 51.537H83.125a6.494 6.494 0 011.169-1.6 6.4 6.4 0 014.54-1.88H90.5a6.42 6.42 0 015.71 3.48z"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M144.237.502H5.397c-2.7 0-4.893 2.711-4.9 6.05v66.192c0 3.339 2.194 6.044 4.9 6.05h138.84c2.7 0 4.893-2.711 4.9-6.05V6.552c0-3.339-2.194-6.044-4.9-6.05zm4.321 72.242c0 2.947-1.936 5.335-4.321 5.338H5.397c-2.385 0-4.317-2.391-4.321-5.338V6.552c0-2.947 1.936-5.335 4.321-5.338h138.84c2.385 0 4.317 2.391 4.321 5.338z",
  fill: "#a59bc3",
  stroke: "#a59bc3",
  opacity: 0.633
});

function SvgStep2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 149.634 79.294",
    className: "w-full h-full"
  }, props), _ref, _ref2, _ref3);
}

export default SvgStep2;